import type { DeckDef } from "@/decks/types";

// Mover una slide = mover su línea. Ocultarla = hidden: true. El motor deriva numeración y progreso del orden.
export const comercialDeck: DeckDef = {
  id: "comercial",
  listed: true,
  languages: ["es", "en"],
  slides: [
    { id: "portada", load: () => import("./slides/PortadaSlide") },
    { id: "historia", load: () => import("./slides/HistoriaSlide"), fragments: 3 },
    { id: "contexto", load: () => import("./slides/ContextoSlide"), fragments: 3 },
    { id: "problema", load: () => import("./slides/ProblemaSlide"), fragments: 2 },
    { id: "quiebres", load: () => import("./slides/QuiebresSlide"), fragments: 2 },
    { id: "capital", load: () => import("./slides/CapitalSlide"), fragments: 2 },
    { id: "desafio", load: () => import("./slides/DesafioSlide"), fragments: 4 },
    { id: "erp-pregunta", load: () => import("./slides/ErpPreguntaSlide") },
    { id: "erp-limite", load: () => import("./slides/ErpLimiteSlide"), fragments: 1 },
    { id: "solucion", load: () => import("./slides/SolucionSlide") },
    { id: "producto", load: () => import("./slides/ProductoSlide"), fragments: 3 },
    { id: "flujo", load: () => import("./slides/FlujoSlide"), fragments: 4 },
    { id: "modulos", load: () => import("./slides/ModulosSlide"), fragments: 4 },
    { id: "funcionalidades", load: () => import("./slides/FuncionalidadesSlide"), fragments: 1 },
    { id: "clasificacion", load: () => import("./slides/ClasificacionSlide"), fragments: 5 },
    { id: "forecast", load: () => import("./slides/ForecastSlide"), fragments: 3 },
    { id: "recomendaciones", load: () => import("./slides/RecomendacionesSlide"), fragments: 4 },
    { id: "impacto", load: () => import("./slides/ImpactoSlide"), fragments: 3 },
    { id: "equipo", load: () => import("./slides/EquipoSlide") },
    { id: "contacto", load: () => import("./slides/ContactoSlide") },
  ],
};
